import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Alert, Spacer, Button, Container, Card, useSnackbar, Typography, TextField } from '@emburse/embark-core';
import { debounce } from 'lodash';
import { sendEmail } from '../../api/accountStatus';
import { $t, useTranslation } from '../../hooks/useTranslation';
import { validateEmail } from '../../util/formValidation';
function AccountStatus({ IsAdmin, FirstName, AdminInfo, Status }) {
    useTranslation();
    // Form Fields
    const [email, setEmail] = useState({
        value: '',
        valid: true,
        validationText: ''
    });
    const [message, setMessage] = useState('');
    const { enqueueSnackbar } = useSnackbar();
    const emailChangeHandler = debounce((e) => {
        setEmail({ validationText: '', valid: true, value: e.target.value });
    }, 300);
    const emailCheckValidity = debounce((e) => {
        setEmail({
            validationText: validateEmail(e.target.value),
            valid: validateEmail(e.target.value).length === 0,
            value: e.target.value
        });
    }, 300);
    const messageChangeHandler = debounce((e) => {
        setMessage(e.target.value);
    }, 300);
    const generateUserMessage = () => {
        if (Status === 'Fraudulent') {
            return (_jsxs(Alert, { severity: "info", style: { marginTop: '48px', width: '600px' }, children: [$t('Your company account is under review.'), _jsx("br", {}), $t('Please contact your administrator for more information.')] }));
        }
        return (_jsxs(Alert, { severity: "info", style: { marginTop: '48px', width: '600px' }, children: [$t("Your company's account has been locked out."), _jsx("br", {}), $t('Please contact your administrator to resolve the issue.')] }));
    };
    const generateAdminMessage = () => {
        if (Status === 'Fraudulent') {
            return (_jsxs(Typography, { variant: "body1", children: [$t('Your company account is under review.'), _jsx("br", {}), $t('Please use the form below to reach out to Certify for more information.')] }));
        }
        return (_jsxs(Typography, { variant: "body1", children: [$t("It appears that you've missed a payment - we'd love to get that fixed for you!"), _jsx("br", {}), $t('Please use the form below to reach out to Certify Billing.')] }));
    };
    const generateSnackbarMessage = () => {
        if (Status === 'Fraudulent') {
            return $t('Your message has been sent to the Certify team, we will be in touch soon.');
        }
        return $t('Your message has been sent to the Certify Billing team, we will be in touch soon.');
    };
    return (_jsxs(_Fragment, { children: [IsAdmin && (_jsxs(Container, { style: { marginLeft: '112px', marginTop: '48px', width: '960px' }, children: [_jsxs(Typography, { variant: "h4", children: [$t('Hi'), "\u00A0", FirstName, ","] }), generateAdminMessage()] })), !IsAdmin && (_jsxs(Container, { style: { marginLeft: '112px', marginTop: '48px', width: '960px' }, children: [_jsxs(Typography, { variant: "h4", children: [$t('Hi'), "\u00A0", FirstName] }), generateUserMessage()] })), IsAdmin && (_jsxs(Container, { style: { marginLeft: '112px', marginTop: '48px', width: '960px' }, children: [_jsx(TextField, { id: "Email", name: "Email", type: "email", label: $t('Your email address'), error: !email.valid, helperText: email.validationText, onBlur: emailCheckValidity, onChange: emailChangeHandler, style: { width: '600px' } }), _jsx(Spacer, { size: 16 }), _jsx(Typography, { variant: "body1", children: "Your message" }), _jsx(TextField, { id: "Message", name: "Email", type: "text", multiline: true, rows: 10, maxRows: 10, onChange: messageChangeHandler, style: { width: '600px' } }), _jsx(Spacer, { size: 48 }), _jsx(Button, { color: "primary", onClick: () => {
                            sendEmail(email.value, message, Status);
                            enqueueSnackbar(generateSnackbarMessage(), {
                                variant: 'alert',
                                AlertProps: { severity: 'success' }
                            });
                        }, size: "large", variant: "contained", children: "Send" })] })), !IsAdmin && (_jsxs(Card, { style: { marginLeft: '136px', marginTop: '48px', width: '600px' }, children: [_jsx(Typography, { variant: "subtitle1", children: "Your Certify Administrator" }), _jsx("div", { dangerouslySetInnerHTML: { __html: AdminInfo } })] }))] }));
}
export default AccountStatus;
